import { useMutation } from "@apollo/client";

import { MapEditorEcologicalFunctionPanel_EcologicalFunctionDeleteDocument } from "./mutations.generated";

export function useDeleteEcologicalFunctionMutation() {
    const [mutate, result] = useMutation(MapEditorEcologicalFunctionPanel_EcologicalFunctionDeleteDocument);

    const deleteEcologicalFunction = (mapEditorFeatureId: string) => {
        return mutate({
            variables: {
                input: {
                    featureId: mapEditorFeatureId,
                },
            },
        });
    };

    return [deleteEcologicalFunction, result] as const;
}
